import React from "react";
import { FaRegTrashCan } from "react-icons/fa6";

interface PaziaTrashButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}
export const PaziaTrashButton = ({
  onClick,
  ...rest
}: PaziaTrashButtonProps): JSX.Element => {
  return (
    <button
      onClick={onClick}
      {...rest}
      className="w-[2.375rem] h-[2.375rem] btn btn bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-rose-500"
    >
      <FaRegTrashCan />
    </button>
  );
};
